export const initialState = [];

export const reducer = (state = initialState, action) => {
  if (action.reminders && action.type === "SET_REMINDERS") {
    return action.reminders;
  } else {
    return state;
  }
};

export default reducer;
